import { getConfig } from "@src/config";
import * as React from "react";

import * as sc from "./ColorItem.sc";

interface IColorFilterProps {
    isSelected: boolean;
    color: string;
    onClick: (selected: boolean) => void;
}

const colorMapAT: { [key: string]: string } = {
    blau: "#0384B3",
    braun: "#A45E40",
    gelb: "#FFBF00",
    gold: "#BEAA85",
    grau: "#808080",
    gruen: "#89B336",
    rot: "#D0031B",
    schwarz: "#000000",
    silber: "#C3C3C3",
    violett: "#675996",
    orange: "#F27318",
    weiss: "#FFFFFF",
};

const colorMapBG: { [key: string]: string } = {
    sin: "#0384B3",
    kafyav: "#A45E40",
    zhult: "#FFBF00",
    zlat: "#BEAA85",
    siv: "#808080",
    zelen: "#89B336",
    cherven: "#D0031B",
    cheren: "#000000",
    srebr: "#C3C3C3",
    lilav: "#675996",
    oranzhev: "#F27318",
    byal: "#FFFFFF",
};

const colorMapRO: { [key: string]: string } = {
    albastru: "#0384B3",
    maro: "#A45E40",
    galben: "#FFBF00",
    aur: "#BEAA85",
    gri: "#808080",
    verde: "#89B336",
    roșu: "#D0031B",
    negru: "#000000",
    argintiu: "#C3C3C3",
    violet: "#675996",
    portocaliu: "#F27318",
    alb: "#FFFFFF",
};

const colorMapSI: { [key: string]: string } = {
    modra: "#0384B3",
    rjava: "#A45E40",
    rumena: "#FFBF00",
    zlata: "#BEAA85",
    siva: "#808080",
    zelena: "#89B336",
    rdeča: "#D0031B",
    črna: "#000000",
    srebrna: "#C3C3C3",
    vijolična: "#675996",
    oranžna: "#F27318",
    bela: "#FFFFFF",
};

function getColorMap() {
    switch (getConfig("scope").domain) {
        case "car4me.bg":
            return colorMapBG;
        case "car4me.ro":
            return colorMapRO;
        case "car4me.si":
            return colorMapSI;
        default:
            return colorMapAT;
    }
}

const resolveHexColor = (color: string): string => {
    const colorMap = getColorMap();

    return colorMap[color];
};

const ColorItem: React.FunctionComponent<IColorFilterProps> = ({ color, isSelected, onClick }) => {
    const hexColor = resolveHexColor(color);

    return hexColor ? (
        <sc.Root isSelected={isSelected} color={hexColor} onClick={onClick.bind(null, !isSelected)}>
            <sc.InnerCircle color={hexColor}>{isSelected && <sc.SelectedIcon />}</sc.InnerCircle>
        </sc.Root>
    ) : null;
};
export default ColorItem;
